import { useState } from 'react';
import ReactPlayer from 'react-player';

import { useAlert } from '../../hooks';

export const usePlayer = () => {
  const [playing, setPlaying] = useState(false);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(false);
  const [player, setPlayer] = useState<ReactPlayer>();

  const { showAlert } = useAlert();

  const ref = (player: ReactPlayer) => {
    setPlayer(player);
  };

  const handlePlayPause = () => {
    setPlaying(!playing);
  };

  const handlePlay = () => {
    setPlaying(true);
  };

  const handlePause = () => {
    setPlaying(false);
  };

  const handleProgress = ({ played }: { played: number }) => {
    setPlayed(played);
  };

  const handleDuration = (duration: number) => {
    setDuration(duration);
  };

  const handleReady = () => {
    setReady(true);
  };

  const handleError = () => {
    setError(true);

    showAlert('Error! Failed to load audio.', { variant: 'error' });
  };

  return {
    state: {
      playing,
      played,
      duration,
      ready,
      error,
      player,
      setPlaying,
      setPlayed,
      setDuration,
      setReady,
      setError,
      setPlayer,
    },
    controls: {
      ref,
      handlePlayPause,
      handlePlay,
      handlePause,
      handleProgress,
      handleDuration,
      handleReady,
      handleError,
    },
  };
};
